import { useEffect, useState } from 'react'
import { ClipboardHeart, Link } from 'react-bootstrap-icons'
import { NavLink } from 'react-router-dom'
import { NavItem } from 'reactstrap'
import Authentication from '../../../../libs/api/services/Authentication'
import QuestionnaireAssignment from '../../../../libs/api/services/QuestionnaireAssignment'

export default function PatientQuestionnairesDashboard() {
    const [questionnaires, setQuestionnaires] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        QuestionnaireAssignment
            .GetUserQuestionnairesByType(Authentication.UserId(), 'Questionnaire')
            .then((r) => {
                setQuestionnaires(r)
                setLoading(false)
            })
    }, [])

    const _transitionToQuestionnaire = (loc) => {
        window.location = loc
    }

    return (
        <div className='text-center h-100'>
            <h1>Questionnaires</h1>
            <>
                <>
                    {
                        loading
                            ?
                            <div className='d-flex justify-content-center align-items-center h-75 flex-column'>
                                <ClipboardHeart className='m-2' size={50} />
                                Loading your questionnaires
                            </div>
                            :
                            questionnaires && (questionnaires.length === 0 || (questionnaires.length > 0 && !questionnaires[0].resource))
                                ?
                                <div className='d-flex justify-content-center align-items-center h-75 flex-column'>
                                    <ClipboardHeart className='m-2' size={50} />
                                    Currently there are no questionnaires for you to complete
                                </div>
                                :
                                <div className='h-100'>
                                    <p>Please complete these questionnaires</p>
                                    <div style={{ overflow: 'auto', height: 'calc(100% - 150px)' }}>
                                        {
                                            questionnaires.map((q, i) => {
                                                return (q.resource &&
                                                    <NavItem key={`${q.resource.id}-${i}`} className='list-unstyled '>
                                                        <NavLink tag={Link} className="list-unstyled text-decoration-none " to={'/Dashboard/Questionnaire/' + q.resource.questionnaire.id + "/" + q.resource.id}>
                                                            <div
                                                                // onClick={(e) => _transitionToQuestionnaire(Authentication.getFacilityRole() + '/Questionnaire/' + q.id)}
                                                                style={{ cursor: 'pointer' }} className='bg-secondary-container m-2 p-2 rounded'>
                                                                <div><ClipboardHeart className='m-2' size={30} /></div>
                                                                {q.resource.questionnaire.name}
                                                            </div>
                                                        </NavLink>
                                                    </NavItem>
                                                )
                                            })

                                        }
                                    </div>
                                </div>
                    }
                </>

            </>
        </div>
    )
}
